import React, {useState} from "react";
import {observer} from "mobx-react";
import Icons from "./Icons";

export default observer(({icon, title, children, ...props}) => {
  return <div {...props}>
    <div className="flex flex-row">
      <div style={{width: "35px"}}>{Icons[icon]}</div>
      <div style={{width: "100%"}}>
        <div className="font-bold text-base">{title}</div>
        {children}
      </div>
    </div>
  </div>
});

